import React from 'react';
import './chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';
import ChapterHeader from '../ChapterHeader/ChapterHeader';
import FloatingCubes from '../FloatingCubes/FloatingCubes';
import imageS from '../../assets/ch3-m.png';
import imageWebP from '../../assets/ch3-m.webp';
function Chapter3() {
  const hyperlinkData = [
    {
      copy: 'Rishikesh Amit Nayak',
      href: 'https://www.intel.com/content/www/us/en/corporate/artificial-intelligence/winners2021.html',
      label: 'Visit Intel® AI Global Impact Festival 2021 Winners page'
    }
  ];
  return (
    <section className="chapters">
      <ChapterHeader chIndex={2} />
      <FloatingCubes origin="ch3" reverse={true} screen="l" />
      <div className="chapters__body">
        <h3 className="chapters__head">
          <span className="chapters__head__number">3</span>
          <span className="chapters__head__copy">
            Restoring and Maximizing Crop Health for Vital Agriculture
          </span>
        </h3>

        <p>
          In 2017, a combination of invasive microbial pests and plant disease wreaked havoc on
          farmers across India. Farms in the Orissa region experienced as much as a 90% crop loss.
          For <Hyperlink hyperlinkData={hyperlinkData[0]} />, an engineering student at a regional
          tech university, the problem was personal. His own family debated abandoning agriculture
          altogether as they struggled to chart a course ahead. With his classmate Niharika Haridas,
          he decided to{' '}
          <span className="bluebold">
            use whatever data he could find to assess the problem with fresh eyes.
          </span>
        </p>
        <p>
          Using satellite-captured thermal scans of the area farms, they found some telltale signs
          of microbial infestations where the losses were most prevalent. With OpenVINO and a suite
          of AI development tools from their university, Nayak and Haridas were able to reliably
          identify early stages of plant disease so farmers could take immediate action before it
          spread.
        </p>
        <div className="chapters__photoS chapters__photoS-3">
          <picture>
            <source srcSet={imageWebP} />
            <source srcSet={imageS} />
            <img src={imageS} alt="" />
          </picture>
        </div>
      </div>
    </section>
  );
}

export default Chapter3;
